export function isValidValue(val) {
  return val !== undefined && val !== null && val !== "";
}

export function isValidArray(response) {
  return isValidValue(response) && Array.isArray(response) && response.length > 0;
}
